module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image9.8c68cc4d.jpg";